import React, { useState } from "react";

import "../../stylesheets/Row.css";
import VtUserManagementRowActions from "./VtUserManagementRowActions";

const getStatusClassName = (status) => {
  const normalized = (status || "").toLowerCase();
  if (normalized === "enabled") {
    return "vt-user-status enabled";
  }
  if (normalized === "disabled") {
    return "vt-user-status disabled";
  }
  return "vt-user-status";
};

const VtUserManagementRow = (props) => {
  const user = props.user;
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <tr className="row" onClick={() => setShowEditModal(true)}>
      <td>{user.email}</td>
      <td>{user.firstName}</td>
      <td>{user.lastName}</td>
      <td className={getStatusClassName(user.status)}>{user.status || "-"}</td>
      <td onClick={(event) => event.stopPropagation()}>
        <VtUserManagementRowActions
          user={user}
          onUpdated={props.onUpdated}
          showEditModal={showEditModal}
          setShowEditModal={setShowEditModal}
        />
      </td>
    </tr>
  );
};

export default VtUserManagementRow;
